import { Component } from '@angular/core';

@Component({
  selector: 'app-table-container',
  template: `
    <div class="container">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        .container {
          flex-grow: 1;
          flex-shrink: 1;
          overflow: auto;
          width: 100%;

          table {
            width: 100%;
            min-width: 1000px;
            table-layout: fixed;

            .mat-column-edit {
              width: 30px;
              padding: 0;
            }

            .mat-column-isActive {
              width: 60px;
            }

            .mat-column-createdDate {
              width: 120px;
            }

            .mat-column-lastLogin {
              width: 120px;
            }

            .mat-column-account {
              width: 70px;
            }

            .cell {
              max-height: 77px;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .edit-user {
              min-width: 30px;
              width: 30px;
              height: 30px;
              line-height: 30px;
            }
          }
        }
      }
    `,
  ],
  standalone: false,
})
export class TableContainerComponent {}
